import {
  cellRenderParseData,
  cellRenderProhibition,
  cellRenderContainerInspectedFlag,
  cellRenderStatus,
  cellRenderStorageTimeCount,
  cellRenderStorageTimeCountOverdue,
  cellRenderRegisterFlag, cellRenderInternalLt
} from '../../utils/functions';
import { cellRenderButtonModalSK } from '../ModalSK/functionModalSK';

/** Список полей */
const columnDataGrid = [
  {
    dataField: 'ttnNumId',
    caption: 'Номер ТН',
    dataType: 'number',
    notVisible: true
  },
  {
    dataField: 'pieceNumId',
    caption: 'Ключ УЕ',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'plantId',
    caption: 'ID склада',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'qcShopCode',
    caption: 'Код цеха отгрузки',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'qcId',
    caption: '№ СК',
    dataType: 'string',
    cellRender: cellRenderButtonModalSK,
    cssClass: 'td-button-cell-render'
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'psStatusNumId',
    caption: 'ID статуса',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ',
    cellRender: cellRenderStatus,
    dataType: 'string'
  },
  {
    dataField: 'soDescrId',
    caption: '№ Заказа',
    dataType: 'string'
  },
  {
    dataField: 'l4SoId',
    caption: '№ СЗ сист.',
    dataType: 'string'
  },
  {
    dataField: 'soLineDescrId',
    caption: 'Позиция заказа',
    dataType: 'number'
  },
  {
    dataField: 'zzordOtsortConf',
    caption: 'Признак ОХ из заказа',
    dataType: 'string'
  },
  {
    dataField: 'productGroupDescription',
    caption: 'Продукт',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: '№ партии',
    dataType: 'string'
  },
  {
    dataField: 'actualPieceId',
    caption: '№ УЕ',
    dataType: 'string'
  },
  {
    dataField: 'heatId',
    caption: '№ плавки',
    dataType: 'string'
  },
  {
    dataField: 'thick',
    caption: 'Толщина, мм',
    dataType: 'number'
  },
  {
    dataField: 'width',
    caption: 'Ширина, мм',
    dataType: 'number'
  },
  {
    dataField: 'widthFact',
    caption: 'Фактическая ширина',
    dataType: 'number'
  },
  {
    dataField: 'length',
    caption: 'Длина, мм',
    dataType: 'number'
  },
  {
    dataField: 'weightNetto',
    caption: 'Вес нетто, т',
    dataType: 'number'
  },
  {
    dataField: 'weightBrutto',
    caption: 'Вес брутто, т',
    dataType: 'number'
  },
  {
    dataField: 'quantity',
    caption: 'Количество',
    dataType: 'number'
  },
  {
    dataField: 'unitShort',
    caption: 'Единица измерения',
    dataType: 'string'
  },
  {
    dataField: 'vehicleIdIn',
    caption: '№ ТС первого плеча',
    dataType: 'string'
  },
  {
    dataField: 'customerName',
    caption: 'Грузополучатель рус.',
    dataType: 'string'
  },
  {
    dataField: 'customerNameEng',
    caption: 'Грузополучатель анг.',
    dataType: 'string'
  },
  {
    dataField: 'shiptoAddressSo',
    caption: 'Адрес получателя рус.',
    dataType: 'string'
  },
  {
    dataField: 'shiptoAddressEnSo',
    caption: 'Адрес получателя англ.',
    dataType: 'string'
  },
  {
    dataField: 'shiptoStationNameSo',
    caption: 'Ст.назначения',
    dataType: 'string'
  },
  {
    dataField: 'shiptoStationCodeSo',
    caption: 'Код станции назначения',
    dataType: 'string'
  },
  {
    dataField: 'shiptoRailwayNameSo',
    caption: 'ЖД назначения',
    dataType: 'string'
  },
  {
    dataField: 'knotPurposeSo',
    caption: 'Целевой узел',
    dataType: 'string'
  },
  {
    dataField: 'shippingPoint',
    caption: 'Пункт отправки',
    dataType: 'string'
  },
  {
    dataField: 'sapId',
    caption: '№ УЭ SAP',
    dataType: 'string'
  },
  {
    dataField: 'shipmentModeRequirement',
    caption: 'Способ отгрузки',
    dataType: 'string'
  },
  {
    dataField: 'planDatePps',
    caption: 'Плановая дата отгрузки с комбината',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'serialId',
    caption: 'Данные штрих-кода для УЭ',
    dataType: 'number'
  },
  {
    dataField: 'container',
    caption: '№ контейнера',
    dataType: 'string'
  },
  {
    dataField: 'dateLoadInContainer',
    caption: 'Дата загрузки контейнера',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'plomba',
    caption: '№ пломбы',
    dataType: 'string'
  },
  {
    dataField: 'incomingDate',
    caption: 'Дата приёмки на склад',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'incomingTime',
    caption: 'Время приёмки на склад',
    dataType: 'string'
  },
  {
    dataField: 'shippingDate',
    caption: 'Дата отгрузки с УС',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'shippingTime',
    caption: 'Время отгрузки с УС',
    dataType: 'string'
  },
  {
    dataField: 'incomingUser',
    caption: 'ФИО принявшего',
    dataType: 'string'
  },
  {
    dataField: 'stockDescr',
    caption: 'Склад',
    dataType: 'string'
  },
  {
    dataField: 'areaDescr',
    caption: 'Зона',
    dataType: 'string'
  },
  {
    dataField: 'boxDescr',
    caption: 'Бокс',
    dataType: 'string'
  },
  {
    dataField: 'qcShopDescr',
    caption: 'Цех-отправитель',
    dataType: 'string'
  },
  {
    dataField: 'documentId',
    caption: '№ Документа',
    dataType: 'string'
  },
  {
    dataField: 'actualShippingDate',
    caption: 'Дата фактической отгрузки',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'returnFlag',
    caption: 'Флаг возврата',
    dataType: 'boolean'
  },
  {
    dataField: 'returnVehicle',
    caption: 'ТС возврата',
    dataType: 'string'
  },
  {
    dataField: 'returnReason',
    caption: 'Причина возврата',
    dataType: 'string'
  },
  {
    dataField: 'returnDate',
    caption: 'Дата возврата',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'plannerNote',
    caption: 'Примечание',
    dataType: 'string',
    width: 100
  },

  {
    dataField: 'deliveryId',
    caption: 'Номер поставки',
    dataType: 'string'
  },
  {
    dataField: 'productType',
    caption: 'Вид продукта (МС для Мастер-рулона)',
    dataType: 'string'
  },
  {
    dataField: 'mcNumId',
    caption: 'Id Мастер-рулона',
    dataType: 'number'
  },
  {
    dataField: 'mcNum',
    caption: 'Мастер-рулона',
    dataType: 'string'
  },
  {
    dataField: 'pfrDescr',
    caption: 'Профилеразмер',
    dataType: 'string'
  },
  {
    dataField: 'kolShtPart',
    caption: 'Количество труб в связке',
    dataType: 'number'
  },
  {
    dataField: 'sposobUkladUpakovka',
    caption: 'Способ отгрузки',
    dataType: 'string'
  },
  {
    dataField: 'ordheadText',
    caption: 'Примечание менеджера SAP',
    dataType: 'string'
  },
  {
    dataField: 'okpoConsignee',
    caption: 'ОКПО грузополучателя',
    dataType: 'string'
  },
  {
    dataField: 'tnglConsignee',
    caption: 'ТНГЛ грузополучателя',
    dataType: 'string'
  },
  {
    dataField: 'innConsignee',
    caption: 'ИНН грузополучателя',
    dataType: 'string'
  },
  {
    dataField: 'contractNoLog',
    caption: 'Договор и наименование покупателя (для СМГС)',
    dataType: 'string'
  },
  {
    dataField: 'eskBuyer',
    caption: 'ЕСК покупателя',
    dataType: 'string'
  },
  {
    dataField: 'eskConsignee',
    caption: 'ЕСК грузополучателя',
    dataType: 'string'
  },
  {
    dataField: 'lprio',
    caption: 'Приоритет поставки',
    dataType: 'string'
  },
  {
    dataField: 'shipperName',
    caption: 'ФИО отгрузившего',
    dataType: 'string'
  },
  {
    dataField: 'invoice',
    caption: 'Номер накладной перв.плеча',
    dataType: 'string'
  },
  {
    dataField: 'wadat_ist',
    caption: 'Дата накладной перв.плеча',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'marka',
    caption: 'Марка стали',
    dataType: 'string'
  },
  {
    dataField: 'buyer',
    caption: 'Наименование покупателя',
    dataType: 'string'
  },
  {
    dataField: 'hasShippingPlan',
    caption: 'Запланировано к отгрузке',
    dataType: 'boolean'
  },
  {
    dataField: 'shippingPlanContainerType',
    caption: 'Тип контейнера',
    dataType: 'string'
  },
  {
    dataField: 'shippingPlanDate',
    caption: 'Плановая дата погрузки экспедитора',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'shippingPlanUserName',
    caption: 'ФИО планировщика',
    dataType: 'string'
  },
  {
    dataField: 'shippingPlanContainerNumber',
    caption: '№ планируемого контейнера',
    dataType: 'string'
  },
  {
    dataField: 'note',
    caption: 'Комментарий',
    dataType: 'string'
  },
  {
    dataField: 'batchId',
    caption: '№ партии SAP',
    dataType: 'string'
  },
  {
    dataField: 'nextPlant',
    caption: 'Следующий экспедитор',
    dataType: 'string'
  },
  {
    dataField: 'nextPlantId',
    caption: 'ID следующего экспедитора',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'freightOrder',
    caption: '№ ФЗ (фрахтовый заказ)',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'onHoldFlag',
    caption: 'Карантин',
    dataType: 'boolean'
  },
  {
    dataField: 'decision',
    caption: 'Решение',
    dataType: 'string'
  },
  {
    dataField: 'departureDate',
    caption: 'Дата убытия баржи',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'conservationQmet',
    caption: 'Тип консервации',
    dataType: 'string'
  },
  {
    dataField: 'grPoverh',
    caption: 'Группа поверхности',
    dataType: 'string'
  },
  {
    dataField: 'prohibition',
    caption: 'Запрет на отгрузку',
    cellRender: cellRenderProhibition,
    cssClass: 'td-button-cell-render',
    dataType: 'string'
  },
  {
    dataField: 'vidProd',
    caption: 'Тип продукта',
    dataType: 'string'
  },
  {
    dataField: 'storageTimeCount',
    caption: 'Срок хранения',
    dataType: 'number'
  },
  {
    dataField: 'remainingTimeCount',
    caption: 'Осталось времени',
    cellRender: cellRenderStorageTimeCount,
    cssClass: 'td-button-cell-render',
    dataType: 'number'
  },
  {
    dataField: 'overStorageTimeCount',
    caption: 'Сверх.норм.хранение',
    cellRender: cellRenderStorageTimeCountOverdue,
    cssClass: 'td-button-cell-render',
    dataType: 'number'
  },
  {
    dataField: 'overStorageDates',
    caption: 'Дата СвН отчета',
    dataType: 'string'
  },
  {
    dataField: 'shippingOnBoards',
    caption: 'Способ погрузки в вагон',
    dataType: 'string'
  },
  {
    dataField: 'containerInspectedFlag',
    caption: 'Осмотр контейнера',
    cellRender: cellRenderContainerInspectedFlag,
    dataType: 'string'
  },
  {
    dataField: 'registerFlag',
    caption: 'Регистр',
    dataType: 'string',
    cellRender: cellRenderRegisterFlag
  },
  // {
  //   dataField: 'vehicleId',
  //   caption: 'Номер ТС/прицепа',
  //   dataType: 'string',
  //   notVisible: false
  // },
  // {
  //   dataField: 'driverNameShort',
  //   caption: 'ФИО водителя',
  //   dataType: 'string',
  //   notVisible: false
  // },
  {
    dataField: 'netWeight',
    caption: 'Вес нетто, т',
    dataType: 'number',
    notVisible: true
  },
  {
    dataField: 'grossWeight',
    caption: 'Вес брутто, т',
    dataType: 'number',
    notVisible: true
  },
  {
    dataField: 'internalLt',
    caption: 'Внутренний LT',
    cellRender: cellRenderInternalLt,
    cssClass: 'td-button-cell-render',
    dataType: 'date'
  },
  {
    dataField: 'pieceId',
    caption: 'Маркировка',
    dataType: 'string'
  },
  {
    dataField: 'endCustomerName',
    caption: 'Конечный потребитель',
    dataType: 'string'
  },
  {
    dataField: 'accountingDocNumber',
    caption: '№ бух. документа',
    dataType: 'string'
  },
  {
    dataField: 'accountingDocDate',
    caption: 'Дата бух. документа',
    dataType: 'date'
  }
];

export default columnDataGrid;
